import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import { Stack, Typography } from '@mui/material';

import { LanguageBar } from 'AppLayout/LanguageBar';
import { Link, Logo } from 'Components';
import { StyledLogo } from 'Components/Styled';
import { urls } from 'Router';

import { BottomContainer } from '../LoginPage/BottomContainer';
import { LinksContainer } from '../LoginPage/LinksContainer';

import { ForgotPasswordFormContainer } from './ForgotPasswordFormContainer';

export const ForgotPasswordPage = () => {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <>
      <StyledLogo>
        <Typography noWrap>{t('auth.resettingPasswordTo')}</Typography>
        <Logo variant="login" />
      </StyledLogo>

      <Typography noWrap style={{ alignSelf: 'center' }}>
        {t('auth.enterYourEmailToResetPassword')}
      </Typography>

      <ForgotPasswordFormContainer email={location.state?.email} />

      <BottomContainer>
        <LinksContainer>
          <Stack direction="row" gap="5px">
            <Typography noWrap>{t('auth.rememberPassword')}</Typography>
            <Link to={urls.loginPage} label={t('auth.login')} shouldOpenInNewTab={false} />
          </Stack>
          <Link
            to={urls.registrationPage}
            label={t('auth.createAccount')}
            shouldOpenInNewTab={false}
          />
          <Link to={urls.treneoSite} label={t('auth.whatIsTreneo')} />
        </LinksContainer>

        <LanguageBar />
      </BottomContainer>
    </>
  );
};
